import React, { useCallback, useRef } from 'react';
import { DocumentRowEditor } from 'components';
import GenericEditor from '../GenericEditor';
import './style.scss';

const ProfileDocumentRow = ({ defaultValue = {}, isOpen, onOpenStateChange, onChange }) => {
  const formRef = useRef();

  // This pattern gives us a way to use our Form components built in validations
  const submit = useCallback(() => {
    if (formRef.current) {
      if (formRef.current.isFormValid && formRef.current.isFormValid()) {
        const values = formRef.current.state.values;
        onChange(values);
        return Promise.resolve();
      } else {
        if (formRef.current.validateForm) {
          formRef.current.validateForm();
        }
        return Promise.reject();
      }
    }
    return Promise.resolve();
  }, [onChange]);

  return (
    <GenericEditor
      className="inline-document-row-editor"
      onSubmit={submit}
      defaultValue={defaultValue}
      isOpen={isOpen}
      onOpenStateChange={onOpenStateChange}
      closeOnOutsideClick={false}
    >
      {({ value, onChange }) => (
        <DocumentRowEditor
          document={value}
          formRef={formRef}
          onChange={onChange}
        />
      )}
    </GenericEditor>
  );
};

export default ProfileDocumentRow;
